import React, { useState } from 'react';

const Bfsimobilecrigot = () => {
    const [flippedTop, setFlippedTop] = useState(false);
    const [flippedRight, setFlippedRight] = useState(false);
    const [flippedBottom, setFlippedBottom] = useState(false);
    const [flippedLeft, setFlippedLeft] = useState(false);

    const handleClickTop = () => setFlippedTop(!flippedTop);
    const handleClickRight = () => setFlippedRight(!flippedRight);
    const handleClickBottom = () => setFlippedBottom(!flippedBottom);
    const handleClickLeft = () => setFlippedLeft(!flippedLeft);

    return (
        <div style={{ marginTop: '100px' }}  className='mobile-crigot'>
            <h1 style={{ color: 'rgb(254 153 0)', textAlign: 'center', marginBottom: "0px",fontSize:'26px' }}>

                CRIGOT framework
                <span style={{ color: '#000', marginLeft: "10px" }}>
                    Offering  </span>
            </h1>
            <section className="circle-section mobile-crigot-section">

                <div className="cards-container mobile-crigot-mobile">

                    <div
                        className="card mobile-crigot-card"
                        style={{ maxHeight: '150px', border: '1px solid rgb(254 175 54)' }}
                    >
                        <div className={`card-inner ${flippedRight ? 'flipped' : ''}`}>
                            <div className="card-front">
                                <p style={{ marginRight: "35px", color: 'rgb(254 175 54)', fontSize: '30px', fontWeight: 'bold', marginTop: '10px' }}>
                                    C<span style={{ color: "#fff" }}>ontrols </span>
                                </p>
                                <p style={{ marginTop: '10px', color: '#fff' }}>
                                Establishing Overarching Controls - "Banking resilience begins with a strong foundation."
                
                                </p>
                                <br />
                            </div>
                            <div className="card-back">
                                <p style={{ color: "#fff", fontSize: "15px" }}>
                                Mandatory for banks and financial institutions, we build a unified control framework aligned with RBI, SEBI, IRDAI, UIDAI, NABARD, and DPDP regulations, ensuring seamless compliance, financial integrity, and cybersecurity resilience.
                
                                </p>
                            </div>
                        </div>


                    </div>





                    <div
                        className="card mobile-crigot-card"
                        style={{ maxHeight: '150px', border: '1px solid rgb(254 175 54)', marginTop:'400px' }}
                    >
                        <div className={`card-inner ${flippedRight ? 'flipped' : ''}`}>
                            <div className="card-front">
                                <p style={{ marginRight: "0px", color: 'rgb(254 175 54)', fontSize: '30px', fontWeight: 'bold', marginTop: '10px' }}>
                                    R<span style={{ color: "#fff" }}>isk & <span style={{ color: 'rgb(254 175 54)', }}>I</span>mpact</span>
                                </p>
                                <p style={{ marginTop: '10px', color: '#fff' }}>
                                "Risk & Impact Assessment - "Transforming risk into opportunity through precision analytics."
                
                                </p>
                                <br />
                            </div>
                            <div className="card-back">
                                <p style={{ color: "#fff", fontSize: "15px" }}>
                                We conduct rigorous risk and impact assessments, identifying vulnerabilities in IT security, financial governance, and regulatory controls to mitigate compliance gaps under SWIFT CSCF, SEBI Cyber Resilience, and Information Systems Audit mandates.
               
                                </p>
                            </div>
                        </div>

                        <style jsx>{`
    .top::-webkit-scrollbar {
      width: 1px; /* Decrease scrollbar width */
    }

    .top::-webkit-scrollbar-thumb {
      background-color: rgba(255, 149, 0, 0.7); /* Optional: style the scrollbar thumb */
      border-radius: 10px;
    }

    .card-inner {
      width: 100%;
      height: 100%;
      position: relative;
      transform-style: preserve-3d; /* Ensure 3D effect */
      transition: transform 0.8s; /* Smooth flip effect */
    }

    .card-inner:hover {
      transform: rotateY(180deg); /* Flip the card on hover */
    }

    .card-front, .card-back {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      backface-visibility: hidden; /* Hide back side when flipped */
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .card-front {
      color: #000;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }

    .card-back {
      color: #000;
      transform: rotateY(180deg); /* Initially rotate the back side */
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1; /* Ensure the back stays behind when flipped */
    }
  `}</style>
                    </div>



                    <div
                        className="card mobile-crigot-card"
                        style={{ maxHeight: '150px', border: '1px solid rgb(254 175 54)', marginTop:'800px' }}
                        onClick={handleClickBottom}
                    >
                        <div className={`card-inner ${flippedBottom ? 'flipped' : ''}`}>
                            <div className="card-front">
                                <p style={{ marginRight: "0px", color: 'rgb(254 175 54)', fontSize: '30px', fontWeight: 'bold', marginTop: '10px' }}>Go<span style={{ color: "#fff" }}>vernance</span></p>
                                <p style={{ marginTop: '10px', color: '#fff' }}>
                                "Governance & Remediation - "From compliance to excellence—strengthening financial governance."
                
                                </p>
                                <br />

                            </div>
                            <div className="card-back">
                                <p style={{ color: "#fff", fontSize: "15px" }}>
                                We remediate deficient controls, fortify cyber defenses, and establish regulatory risk matrices, ensuring robust governance for KYC/AML, UIDAI AUA/KUA, RBI fraud reporting, and VSCC vendor compliance.
               
                                </p>
                            </div>
                        </div>


                    </div>


                    <div
                        className="card mobile-crigot-card"
                        style={{ maxHeight: '150px', border: '1px solid rgb(254 175 54)', marginTop:'1200px' }}
                        onClick={handleClickLeft}
                    >
                        <div className={`card-inner ${flippedLeft ? 'flipped' : ''}`}>
                            <div className="card-front">
                                <p style={{ marginRight: "35px", color: 'rgb(254 175 54)', fontSize: '30px', fontWeight: 'bold', marginTop: '10px' }}>
                                    T<span style={{ color: "#fff" }}>ransformation</span>
                                </p>
                                <p style={{ marginTop: '10px', color: '#fff' }}>
                                "Transformation - "Future-proofing financial institutions with intelligent compliance."
               
                                </p>
                                <br />

                            </div>
                            <div className="card-back">
                                <p style={{ color: "#fff", fontSize: "15px" }}>
                                We embed AI-driven risk intelligence, automated regulatory tracking, and next-gen security frameworks, enabling banks to achieve continuous compliance while driving innovation in a highly regulated, data-sensitive financial ecosystem.
                
                                </p>
                            </div>
                        </div>


                    </div>



                </div>

                <style jsx>{`
        .circle-section {
          position: relative;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .circle-animation-container {
          position: absolute;
          width: 650px; /* Increased width of the circle */
          height: 650px; /* Increased height of the circle */
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 0; /* Ensure it stays above the cards */
          animation: rotateCircle 10s infinite linear; /* Apply rotation animation */
        }

        @keyframes rotateCircle {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .circle-animation {
          width: 100%;
          height: 100%;
        }

        .cards-container {
          position: absolute;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 1;
          width: 100%;
          height: 100%;
       
        }

        .card {
          padding: 10px;
          margin: 5px;
          width: 370px;
          height: 150px;
          text-align: center;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          position: absolute;
          transition: box-shadow 0.3s ease; /* Smooth transition for box shadow */
          border: 1px solid #fe9900 ;
          background:#393838;
        }

        .card:hover {
          box-shadow: 0 4px 12px rgba(255, 149, 0, 0.7); /* Change box shadow color on hover */
        }

     
    
      `}</style>
            </section>
        </div>
    );
};

export default Bfsimobilecrigot;
